<template>
  <AdminLayout>
    <DetailForm
      v-if="loaded"
      title="Edit"
      description="This form will edit a advertising budget request"
      action="Save"
      @handle-cancel="$router.go(-1)"
      @handle-action="handleSubmit"
    >
      <DateInput label="Start Date" :model-value="budget_request.start_date" @update:model-value="updateStartDate" />
      <DateInput label="End Date" :model-value="budget_request.end_date" @update:model-value="updateEndDate" />
      <CurrencyInput
        label="Indeed Spend"
        :model-value="budget_request.indeed_spend"
        @update:model-value="updateIndeedSpend"
      />
      <CurrencyInput label="Zip Spend" :model-value="budget_request.zip_spend" @update:model-value="updateZipSpend" />
      <CurrencyInput
        label="Monster Spend"
        :model-value="budget_request.monster_spend"
        @update:model-value="updateMonsterSpend"
      />
      <CurrencyInput
        label="Meta Spend"
        :model-value="budget_request.meta_spend"
        @update:model-value="updateMetaSpend"
      />
      <SelectMenu
        label="Status"
        :options="['rejected', 'pending', 'completed']"
        :initial-value="budget_request.status"
        @selected-option="budget_request.status = $event"
      />
    </DetailForm>
  </AdminLayout>
</template>

<script>
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import AdminLayout from '@/components/layouts/AdminLayout/index.vue';
import DetailForm from '@/components/shared/DetailForm.vue';
import { toast } from 'vue-sonner';

export default {
  components: {
    AdminLayout,
    DetailForm,
  },
  props: ['record'],
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      budget_request: {
        start_date: '',
        end_date: '',
        indeed_spend: 0,
        zip_spend: 0,
        monster_spend: 0,
        meta_spend: 0,
        status: '',
      },
      loaded: false,
    };
  },
  mounted() {
    this.getContact();
  },
  methods: {
    getContact() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch(`/api/admin/monthly_marketing_budget_update_requests/${self.$route.params.id}`)
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.budget_request = data.record;
          self.loaded = true;
        });
    },
    updateStartDate(value) {
      this.budget_request.start_date = value;
    },
    updateEndDate(value) {
      this.budget_request.end_date = value;
    },
    updateIndeedSpend(value) {
      this.budget_request.indeed_spend = value;
    },
    updateZipSpend(value) {
      this.budget_request.zip_spend = value;
    },
    updateMonsterSpend(value) {
      this.budget_request.monster_spend = value;
    },
    updateMetaSpend(value) {
      this.budget_request.meta_spend = value;
    },
    handleSubmit() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch(`/api/admin/monthly_marketing_budget_update_requests/${self.$route.params.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          start_date: self.budget_request.start_date,
          end_date: self.budget_request.end_date,
          indeed_spend: self.budget_request.indeed_spend,
          zip_spend: self.budget_request.zip_spend,
          monster_spend: self.budget_request.monster_spend,
          meta_spend: self.budget_request.meta_spend,
          status: self.budget_request.status,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {
          return response.json();
        })
        .then(async data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            await self.$router.push(`/admin/budget_requests?sort=created&order=desc&status=Pending`);
            toast.success('Advertising Budget Request edited', {
              action: { label: 'Dismiss' },
              description:
                'Your Advertising Budget Request was successfully edited.  Use the button below to dismiss this alert.',
            });
          } else {
            toast.error('Advertising Budget Request edit error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });
          }
        });
    },
  },
};
</script>
